// utilities
import api from '@/utilities/api'

export const updateDateRange = ({ commit, dispatch }, payload) => {
  commit('setDateRange', payload)
}

export const getAccountEntries = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/financial/accountEntries/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setAccountEntries', response.data)
    }
  })
}
export const getGateCampingReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/gate/camping/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setGateCampingReport', response.data)
    }
  })
}
export const getGateParkingReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/gate/parking/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setGateParkingReport', response.data)
    }
  })
}
export const getCampgroundReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/camping/campground/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setCampgroundReport', response.data)
    }
  })
}

export const getCampsiteReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/camping/campsite/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setCampsiteReport', response.data)
    }
  })
}

export const getParkingReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/parking/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setParkingReport', response.data)
    }
  })
}

export const getGatePassReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/gatePass/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setGatePassReport', response.data)
    }
  })
}

export const getInvoiceSourceReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: `private/reports/misc/invoiceSource/${state.dateRange.startDate}/${state.dateRange.endDate}`,
    success (response) {
      commit('setInvoiceSourceReport', response.data)
    }
  })
}

export const getGeneratedReport = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'post',
    endpoint: `private/reports/generate`,
    payload: {
      ...payload,
      ...state.dateRange
    },
    success (response) {
      commit('setGeneratedReport', response.data)
    }
  })
}

export const getErrorLog = ({ commit, dispatch, state }, payload) => {
  return api.request({
    method: 'get',
    endpoint: 'private/utilities/errorLog',
    success (response) {
      commit('setErrorLog', response.data)
    }
  })
}
